import { useSearchParams } from "react-router-dom";
import Faq from "../components/Faq";
import { APP_STORE_URL, GOOGLE_PLAY_URL } from "../data/links";
import { useT } from "../i18n";

function SuccessCheck() {
  return (
    <span className="w-20 h-20 rounded-full bg-success flex items-center justify-center">
      <svg width="44" height="44" viewBox="0 0 24 24" fill="none">
        <path d="M5 13l4 4L19 7" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    </span>
  );
}

function StoreButton({ href, label }: { href: string; label: string }) {
  const disabled = !href;
  if (disabled) {
    return (
      <span
        aria-disabled="true"
        className="w-full h-14 rounded-[14px] bg-white/[0.06] text-muted font-semibold text-base flex items-center justify-center cursor-not-allowed select-none"
      >
        {label}
      </span>
    );
  }
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="w-full h-14 rounded-[14px] bg-violet-grad text-white font-extrabold text-base flex items-center justify-center active:opacity-90 transition-opacity shadow-violet-btn"
    >
      {label}
    </a>
  );
}

export default function Done() {
  const { t } = useT();
  const [params] = useSearchParams();
  const phone = params.get("phone") || "";

  return (
    <div className="min-h-dvh flex flex-col px-7 py-8 max-w-md mx-auto">
      <div className="flex flex-col items-center text-center pt-6">
        <SuccessCheck />
        <h1 className="mt-6 text-[30px] font-extrabold tracking-tight">{t("done.title")}</h1>
        <p className="mt-3 text-muted text-base leading-relaxed">{t("done.subtitle")}</p>
      </div>

      <div className="mt-8 flex flex-col gap-6">
        <section className="flex flex-col gap-3">
          <p className="text-sm text-white/80 leading-relaxed text-center">
            {phone
              ? t("done.appHintWithPhone", { phone })
              : t("done.appHintNoPhone")}
          </p>
          <StoreButton href={APP_STORE_URL} label={t("done.appStore")} />
          <StoreButton href={GOOGLE_PLAY_URL} label={t("done.googlePlay")} />
          {!APP_STORE_URL && !GOOGLE_PLAY_URL && (
            <p className="text-xs text-muted text-center">{t("done.linksSoon")}</p>
          )}
        </section>

        <Faq />
      </div>
    </div>
  );
}
